<template>
  <div :class="{'modal-box': viewBorder, 'pic-container': true}">
    <h3
      v-if="showTitle"
      class="modal-title"
    >
      {{ modalTitle }}
      <span
        v-if="showTips"
        style="padding-left:20px; color:red"
      >
        上传照片大小：小于{{ maxSize }}M; 允许上传的图片格式：png、jpg、jpeg、gif
      </span>
    </h3>
    <div :class="{'modal-row-box': viewBorder, 'pic-upload': true}">
      <el-upload
        :ref="refName"
        :class="{'upload-file': true, 'hide': hideUpload, 'is-disabled': disabled}"
        list-type="picture-card"
        :action="serverUrl + uploadAction"
        :headers="headers"
        :data="requestParam"
        :file-list="fileList"
        :before-upload="handleBeforeUpload"
        :on-change="handleOnChange"
        :on-success="handleOnSuccess"
        :on-error="handleOnError"
        :on-remove="handleOnRemove"
        :on-preview="handleOnPreview"
        :on-exceed="handleOnExceed"
        multiple
        :auto-upload="true"
        :limit="limit"
        :accept="accept"
        :with-credentials="true"
        :disabled="disabled"
      >
        <i class="el-icon-plus" />
      </el-upload>

      <!-- 图片预览 -->
      <el-image-viewer
        v-if="showViewer"
        :z-index="5000"
        :on-close="() => {showViewer = false}"
        :url-list="imagePreviewUrls"
        :initial-index="initialImgPreviewIndex"
        class="image-viewer"
      />
    </div>
  </div>
</template>

<script>
// 拖拽
import Sortable from 'sortablejs';
// 授权TOKEN
import { getToken, getUserInfo } from "@/utils/auth"
// 附件API
import { deleteFileApi } from '@/api/v2/attachmentInfo';

export default {
  name: "UploadImageComponent",
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  props: {
    refName: {
      type: String,
      default: 'upload-image'
    },
    fileList: {
      type: Array,
      default () {
        return []
      }
    },
    dataId: {
      type: Number,
      default: null
    },
    modalTitle: {
      type: String,
      default: '照片信息'
    },
    directory: {
      type: String,
      default: ''
    },
    paramData: {
      type: Object,
      default: null
    },
    accept: {
      type: String,
      default: '.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF'
    },
    maxSize: {
      type: Number,
      default: 10
    },
    limit: {
      type: Number,
      default: 1
    },
    viewBorder: {
      type: Boolean,
      default: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    showTips: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      serverUrl: process.env.VUE_APP_FILE_V2_API,
      uploadAction: '/file/uploadFile',
      requestParam: {},
      headers: {},
      hideUpload: false,
      showViewer: false,
      // 预览图片URL列表
      imagePreviewUrls: [],
      // 预览打开看到的图片下标
      initialImgPreviewIndex: 0,
    }
  },
  computed: {
    computedFileList: {
      get () {
        return this.fileList
      },
      set (val) {
        this.$emit('update:file-list', val)
      }
    }
  },
  created () {
    let _this = this;
    let user = JSON.parse(getUserInfo());
    _this.headers["X-Token"] = getToken();
    _this.requestParam["token"] = getToken();
    _this.requestParam["creatorId"] = user.id;
    _this.requestParam["creatorName"] = user.name;
    _this.requestParam["operatorId"] = user.id;
    _this.requestParam["operatorName"] = user.name;
    if (_this.disabled) {
      _this.hideUpload = true
    }
  },
  mounted () {
    let _this = this;
    if (_this.paramData) {
      _this.requestParam = { ..._this.requestParam, ..._this.paramData };
    }
    if (_this.directory) {
      _this.requestParam["directory"] = _this.directory;
    }
    if (!_this.disabled) {
      _this.initDropSort();
    }
  },
  methods: {
    getToken,
    // 初始化Sortable
    initDropSort () {
      let _this = this;
      const elList = _this.$refs[_this.refName].$el.querySelector('.upload-file .el-upload-list--picture-card');
      new Sortable(elList, {
        draggable: ".el-upload-list__item",
        delay: 0,
        onEnd: ({ newIndex, oldIndex }) => { // 监听拖动结束事件
          //如果位置一样return
          if (newIndex == oldIndex) {
            return;
          }
          const currRow = _this.fileList.splice(oldIndex, 1)[0]
          _this.fileList.splice(newIndex, 0, currRow)
        }
      })
    },
    // 预览大图
    handleOnPreview (file) {
      let _this = this
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      if ('.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF'.indexOf(extension) > -1) {
        _this.fileList.forEach((item) => {
          _this.imagePreviewUrls.push(item.url)
        })
        let index = _this.imagePreviewUrls.indexOf(file.url)
        if (index >= 0) {
          _this.initialImgPreviewIndex = index
        }
        _this.showViewer = true
      } else {
        _this.$message.error('该文件格式暂不支持预览')
      }
    },
    // 上传文件列表变更
    handleOnChange (file, fileList) {
      this.hideUpload = fileList.length >= this.limit
    },
    // 上传之前处理
    handleBeforeUpload (file) {
      let _this = this;
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      let size = file.size / 1024 / 1024
      if (_this.accept.indexOf(extension) < 0) {
        _this.$message.error('文件格式错误')
        return false
      } else if (size > _this.maxSize) {
        _this.$message.error('图片超过限定大小 ' + _this.maxSize + 'M')
        return false
      } else {
        return true
      }
    },
    // 上传成功
    handleOnSuccess (response, file, fileList) {
      let _this = this;
      if (fileList.every(item => item.status == 'success')) {
        fileList.forEach(item => {
          if (item.response) {
            if (item.response.code === 100000) {
              item.response.data.forEach(attachment => {
                _this.fileList.push({
                  name: file.name,
                  url: _this.serverUrl + attachment.url,
                  baseUrl: attachment.url,
                  suffix: attachment.suffix,
                  md5: attachment.md5,
                  id: null
                });
              });
            } else {
              _this.$message.error(item.response.message);
            }
          }
        })
      }
    },
    // 上传失败
    handleOnError (err, file) {
      this.$message.error('《' + file.name + '》上传失败')
    },
    // 超出限制
    handleOnExceed () {
      this.$message.error('最多允许上传' + this.limit + '张图片')
    },
    // 删除
    handleOnRemove (file) {
      let _this = this;
      _this.computedFileList = _this.fileList.filter(
        v => file.baseUrl.indexOf(v.baseUrl) < 0
      )
      if (file.baseUrl && !file.id) {
        deleteFileApi({ filePath: file.baseUrl }).then(() => {
          _this.$message({ message: '图片删除成功', type: 'success' });
        })
      }
      _this.hideUpload = false
    },
  }
}
</script>
<style lang="scss" scoped>
.upload-file {
  display: flex;

  ::v-deep .el-upload--picture-card {
    height: 150px !important;
    width: 150px !important;
    line-height: 158px !important;
    min-width: 150px;
    margin: 5px 0;
  }
  ::v-deep .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    height: auto !important;
  }
  ::v-deep .el-upload-list--picture-card {
    display: flex;
    flex-flow: row wrap;
  }
  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    height: 150px !important;
    width: 150px !important;
    margin: 5px 5px 5px 0;
    display: flex !important;
    align-items: center !important;
  }
  ::v-deep .el-upload-list--picture-card .el-progress {
    width: 150px !important;
    ::v-deep .el-progress-circle {
      height: 150px !important;
      width: 150px !important;
    }
  }
  ::v-deep .el-progress--circle .el-progress__text {
    font-size: 12px !important;
  }
  ::v-deep.is-disabled {
    .el-upload-list__item-status-label {
      display: none;
    }
  }
  ::v-deep .is-disabled + div {
    display: none;
  }
}

::v-deep .hide .el-upload--picture-card {
  display: none;
}
</style>